module.exports = function indicator (i) {
  var cent = i % 100
  if (cent >= 10 && cent <= 20) return 'th'
  var dec = i % 10
  if (dec === 1) return 'st'
  if (dec === 2) return 'nd'
  if (dec === 3) return 'rd'
  return 'th'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ordinal/indicator.js
// module id = 1602
// module chunks = 0